import { t, Trans } from "app/utils";
import React from "react";
import TrendingStoriesSlider from "./TrendingStoriesSlider";

const TrendingStories = ({
  forYou,
  openModal,
  ignoreTrending,
  isProfile,
  queryString,
  onStoryClick,
  selectedStory,
  showPoints,
  onPosted,
  userAnsweredStories
}) => (
  <section aria-label={t("Trending stories section")}>
    <div className="Trending-Stories">
      <h2 className="title-hidden"><Trans>Trending stories</Trans></h2>
      <TrendingStoriesSlider
        openModal={openModal}
        ignoreTrending={ignoreTrending}
        isProfile={isProfile}
        queryString={queryString}
        forYou={forYou}
        onPosted={onPosted}
        onStoryClick={onStoryClick}
        selectedStory={selectedStory}
        showPoints={showPoints}
        userAnsweredStories={userAnsweredStories}
      />
    </div>
  </section>
);

export default TrendingStories;
